if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      if (this.elements.viewer.splideInstance) {
        this.elements.viewer.splideInstance.on('moved', this.onSlideChanged.bind(this));
      } else {
        this.elements.viewer.addEventListener('splide:mounted', () => {
          this.elements.viewer.splideInstance.on('moved', this.onSlideChanged.bind(this));
        });
      }
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('a').addEventListener('click', (event) => {
          event.preventDefault();
          this.setActiveMedia(mediaToSwitch.dataset.target);
        });
      });
    }

    onSlideChanged(newIndex) {
      const currentSlide = this.elements.viewer.querySelectorAll('.splide__slide')[newIndex];
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${currentSlide.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail, newIndex);
    }

    setActiveMedia(mediaId) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      // get activeMedia index
      const activeMediaIndex = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).indexOf(activeMedia);

      this.preventStickyHeader();

      // go to activeMedia index
      if (this.elements.viewer.splideInstance) {
        this.elements.viewer.splideInstance.go(activeMediaIndex);
      }

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail, activeMediaIndex);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail, activeMediaIndex) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('a').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('a').setAttribute('aria-current', true);

      if (this.elements.thumbnails.splideInstance) {
        this.elements.thumbnails.splideInstance.go(activeMediaIndex);
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
  });
}
